export default {
  nav: {
    solutions: 'Решения',
    cases: 'Кейсы',
    kol: 'Партнерство KOL',
    contact: 'Связаться',
    login: 'Вход для компаний'
  },
  hero: {
    badge: 'Связь в реальном времени на базе ИИ',
    title: 'Идеальная связь в реальном времени для игровых компаний по всему миру',
    subtitle: 'Глубокая интеграция алгоритмов ИИ и WebRTC, предоставляющая сверхнизкую задержку и высококачественные аудио- и видеорешения для разработчиков игр, поддерживающая кроссплатформенное взаимодействие, перевод голоса в реальном времени и интеллектуальную оптимизацию видео',
    cta: 'Начать бесплатно',
    learn: 'Узнать больше',
    latency: 'Сверхнизкая задержка',
    nodes: 'Глобальные узлы',
    uptime: 'Время работы'
  },
  features: {
    title: 'Основные технологические преимущества',
    subtitle: 'Глубокая интеграция ИИ и WebRTC для идеального игрового общения',
    ai: {
      title: 'Умная оптимизация ИИ',
      desc: 'Интеллектуальное шумоподавление, подавление эха и улучшение видео для кристально чистой связи'
    },
    translate: {
      title: 'Перевод в реальном времени',
      desc: 'Поддержка многоязычного перевода в реальном времени, преодоление языковых барьеров и связь игроков по всему миру'
    },
    global: {
      title: 'Глобальное покрытие узлов',
      desc: '200+ глобальных узлов с интеллектуальной маршрутизацией для минимальной задержки и лучшего качества соединения'
    },
    security: {
      title: 'Безопасность корпоративного уровня',
      desc: 'Сквозное шифрование, безопасные и надежные данные, соответствие международным стандартам конфиденциальности'
    }
  },
  solutions: {
    title: 'Решения',
    subtitle: 'Профессиональные решения для аудио- и видеосвязи для различных игровых сценариев',
    streaming: {
      title: 'Решение для игровых трансляций',
      desc: 'Предоставление технологии потоковой передачи со сверхвысоким разрешением и низкой задержкой для игровых стримеров, поддержка миллионов одновременных зрителей с взаимодействием в реальном времени без задержек. Фильтры красоты на базе ИИ и эффекты делают трансляции более привлекательными.',
      f1: 'Потоковая передача 4K со сверхвысоким разрешением с задержкой 25 мс',
      f2: 'Фильтры красоты ИИ и эффекты в реальном времени',
      f3: 'Поддержка миллионов одновременных зрителей'
    },
    voice: {
      title: 'Решение для командного голоса',
      desc: 'Профессиональная командная голосовая связь для соревновательных игр, таких как MOBA и Battle Royale, поддержка пространственного аудиопозиционирования для точного определения местоположения товарищей по команде. Шумоподавление ИИ обеспечивает четкую связь.',
      f1: '3D пространственное аудио для точного позиционирования',
      f2: 'Шумоподавление ИИ устраняет фоновый шум',
      f3: 'Поддержка 100 одновременных голосовых пользователей'
    },
    social: {
      title: 'Решение для социального взаимодействия',
      desc: 'Многопользовательские видеозвонки, виртуальные подарки и взаимодействие в реальном времени для социальных игр. Поддержка перевода голоса в реальном времени для беспрепятственного общения между игроками из разных стран.',
      f1: 'Многопользовательские видеозвонки, до 16 пользователей',
      f2: 'Перевод в реальном времени, 50+ языков',
      f3: 'Виртуальные подарки и интерактивные эффекты'
    },
    acceleration: {
      title: 'Решение для ускорения игр',
      desc: 'На основе глобальных распределенных узлов и интеллектуальных алгоритмов маршрутизации, предоставление услуг сетевого ускорения для игр, эффективное снижение задержки и потери пакетов. Поддержка оптимизации нескольких игровых протоколов для обеспечения плавного игрового опыта.',
      f1: 'Интеллектуальная маршрутизация, снижение задержки на 60%+',
      f2: 'Многопротокольная оптимизация, ускорение UDP/TCP',
      f3: '200+ глобальных узлов, ближайший доступ'
    }
  },
  cases: {
    title: 'Истории успеха',
    subtitle: 'Предоставление профессиональных услуг аудио- и видеосвязи для сотен игровых компаний по всему миру',
    moba: {
      title: 'Соревновательная игра MOBA',
      desc: 'Предоставление услуг глобальной трансляции турниров и командного голоса для известной игры MOBA, поддержка 500 тыс.+ одновременных пользователей с задержкой 18 мс, обеспечение плавных киберспортивных мероприятий.',
      s1: 'Одновременные пользователи',
      s2: 'Средняя задержка',
      s3: 'Время работы'
    },
    battle: {
      title: 'Игра Battle Royale',
      desc: 'Предоставление голосовой связи для комнат на 100 игроков для игр battle royale, 3D пространственное аудио помогает игрокам точно определять местоположение врагов, шумоподавление ИИ обеспечивает четкую связь, улучшая соревновательный игровой опыт.',
      s1: 'Вместимость комнаты',
      s2: 'Задержка голоса',
      s3: 'Удовлетворенность пользователей'
    },
    casual: {
      title: 'Социальная казуальная игра',
      desc: 'Предоставление видеозвонков и потоковых услуг для платформ социальных игр, с более чем 1 млн ежедневных активных пользователей, поддержка перевода голоса в реальном времени, связь глобальных игроков для международного социального опыта.',
      s1: 'Ежедневные активные пользователи',
      s2: 'Ежедневные трансляции',
      s3: 'Уровень удержания'
    }
  },
  kol: {
    title: 'Программа партнерства KOL',
    subtitle: 'Приглашаем игровых стримеров и создателей контента присоединиться к партнерской программе CM-Tong',
    b1: {
      title: 'Выделенная поддержка',
      desc: 'Выделенная техническая команда поддержки с приоритетным доступом к новейшим функциям'
    },
    b2: {
      title: 'Распределение доходов',
      desc: 'Распределение доходов от партнерства, выгода от роста платформы'
    },
    b3: {
      title: 'Продвижение бренда',
      desc: 'Продвижение через официальные каналы для повышения влияния личного бренда'
    },
    b4: {
      title: 'Приоритетные преимущества',
      desc: 'Приоритетное участие в мероприятиях платформы для большей видимости'
    },
    cta: 'Подать заявку на партнерство'
  },
  contact: {
    title: 'Связаться с нами',
    subtitle: 'Заполните ваши требования, и мы свяжемся с вами в течение 24 часов',
    name: 'Имя',
    email: 'Email',
    company: 'Название компании',
    message: 'Сообщение',
    submit: 'Отправить',
    submitting: 'Отправка...',
    success: 'Успешно отправлено! Мы свяжемся с вами в ближайшее время'
  },
  login: {
    title: 'Вход для компаний',
    subtitle: 'Войдите в свою корпоративную учетную запись, чтобы начать использовать платформу CM-Tong',
    email: 'Корпоративный email',
    emailPlaceholder: 'Введите корпоративный email',
    password: 'Пароль',
    passwordPlaceholder: 'Введите пароль',
    remember: 'Запомнить меня',
    forgot: 'Забыли пароль?',
    submit: 'Войти',
    noAccount: 'Нет учетной записи?',
    signup: 'Зарегистрироваться сейчас',
    back: 'Вернуться на главную'
  },
  footer: {
    desc: 'CM-Tong - это профессиональная платформа аудио и видео AI+WebRTC, предоставляющая эффективные решения связи в реальном времени с низкой задержкой для глобальных игровых компаний.',
    product: 'Продукт',
    company: 'Компания',
    rights: 'Все права защищены'
  }
};
